import { IonRadio, IonRadioGroup } from '@ionic/react';
import { FormControlLabel, Radio, RadioGroup } from '@mui/material';
import { IQuestionTypeModel } from 'models/QuestionType.Model'
import React, { InputHTMLAttributes, useEffect, useState } from 'react'
import { Col, FormGroup, Input, Label, Row } from 'reactstrap';

interface inputProps extends InputHTMLAttributes<HTMLInputElement> {
    data: Array<IQuestionTypeModel>,
    index: any,
    elementRef: any,
    clickHandler: any,
    defaultSelected?: boolean
}

function OptionQuestions({ data, index, elementRef, clickHandler, defaultSelected, ...rest }: inputProps, ref) {
    // const [selectedradio, setSelectedRadio] = useState<number>();
    const [selectedId, setSelectedId] = useState<number>(0);

    const onOptionRadioGroup = (Id: any, questions: IQuestionTypeModel[]) => {
        let id = parseInt(Id);
        if (questions && questions.length > 0) {
            setSelectedId(id);
            for (const list of questions) {
                list.Response = (list.Id === id) ? true : null;
                clickHandler(list.Id === id, list, index);
            }
        }
    }

    useEffect(() => {
        let selectedValueId = data.find(x => x.Response === true)?.Id as any;
        setSelectedId(selectedValueId);
        // setSelectedRadio(selectedValueId)
    }, [data, selectedId])

    return (
        <RadioGroup value={selectedId} onChange={(e) => onOptionRadioGroup(e.target.value, data)} className='font-size-12' sx={{
            fontSize: '12'
        }}>
            <Row>
                {data.map((option: IQuestionTypeModel, Index: any) => (
                    <Col ref={elementRef} key={Index} lg="12" md="12" sm="12" xs="12">
                        <div className="p-0 m-0 d-flex px-2">
                            <Radio value={option.Id} key={option.Id} size='small' ></Radio>
                            <p className="m-0 mt-2">{option.DisplayName}</p>
                        </div>
                    </Col>
                ))
                }
            </Row>
        </RadioGroup>
        // <CustomRadioGroup ref={elementRef} data={data} value={selectedradio ? selectedradio : selectedId} displayName={'DisplayName'} direction={'vertical'} onChange={(e) => onOptionRadioGroup(e.target.value, data)} />
        // <>
        //     {data.map((option: IQuestionTypeModel, i: any) => (
        //         <FormGroup style={{ display: "unset" }}>
        //             <FormGroup check key={i}>
        //                 <Label check>
        //                     <Input value={option.Id} key={option.Id} type="radio" name="custom-radio" />
        //                     <p className="questionaire-option"  >{option.DisplayName}</p>
        //                 </Label>
        //             </FormGroup>
        //         </FormGroup>
        //     ))}
        // </>
    )
}

export default OptionQuestions
